// src/services/financeiro/AssinaturaService.js
import axios from 'axios';
import { fetchData } from '../Api';

export const buscarStatusCliente = async (cnpj) => {
  return await fetchData('/StatusCliente/VerStatus', { cnpj });
};

export const buscarPixAssinatura = async (token) => {
  const baseURL = window.APP_CONFIG?.Url_Api || 'http://default-url.com';
  const response = await axios.get(`${baseURL}/Pix/Assinatura/${token}`);
  return response.data;
};
